import { FC, memo, useCallback, useEffect, useMemo } from 'react';
import { Button } from 'antd';
import Icon from '@ant-design/icons';
import { TagButtonProps } from './TagButton.types';
import { ConfigProvider } from 'antd';
import Link from 'next/link';
import Image from 'next/image';
import styles from './TagButton.module.scss';
import ArrowRight from '@/public/assets/arrow-right.svg';
import { CheckCircleTwoTone, HeartTwoTone, SmileTwoTone } from '@ant-design/icons';
import { topicTagsMap } from './utils';

const TagButton = memo((props: TagButtonProps) => {
  const { title, onClickEvent, hideIcon, emoji, targetUrl } = props;

  return (
    <a
      href={targetUrl}
      style={{ display: 'block', height: 'auto' }}
      className={styles.tag_container}
    >
      <ConfigProvider
        theme={{
          components: {
            Button: {
              fontWeight: 700,
              contentFontSize: 20,
              defaultColor: '#E87722',
              defaultBorderColor: '#E87722',
              defaultBg: '#ffffff',
              paddingBlock: '12px 24px'
            }
          }
        }}
      >
        <Button className={styles.tag_button}>
          {/* {!hideIcon && <Icon component={ArrowRight} style={{ fontSize: 24 }} />}
           */}
          {/* <HeartTwoTone twoToneColor="#eb2f96" /> */}
          <span className={styles.tag_button_title}>
            {emoji} {title}
          </span>
        </Button>
      </ConfigProvider>
    </a>
  );
});
export default TagButton;
